<template>
    <div class="PointTotal">
        <el-row :gutter="20">
            <el-col :span="8">
                <div class="Total_Wrap">
                    <div>提货金余额</div>
                    <div>
                        <span>{{data.fee}}</span>
                        <span>元</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="Total_Wrap">
                    <div>库存余额</div>
                    <div>
                        <span>{{data.fee_goods}}</span>
                        <span>元</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="Total_Wrap">
                    <div>服务费金额</div>
                    <div>
                        <span>{{data.balance}}</span>
                        <span>元</span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data() {
        return {

        };
    },
    props: {
        data:{
            type:Object
        }
    }
}
</script>
<style lang="less" scoped>
.PointTotal {
    background: #f7f7f7;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    .Total_Wrap {
        div {
            text-align: center;
        }
        div:first-child {
            font-size: 14px;
            font-weight: normal;
            padding-bottom: 10px;
            color: #666666;
        }
        div:last-child {
            span:first-child {
                font-size: 20px;
                font-weight: 600;
                margin-right: 4px;
            }
            span:last-child {
                font-size: 14px;
                font-weight: normal;
                padding-bottom: 10px;
            }
        }
    }
}
.el-tabs__header{
    margin-bottom: 0 !important;
}
</style>